import React from 'react';

import { get } from 'lodash';

import { BASE_URL, MEDIA_URL } from '@/axios';

import styles from './songNameWithPhoto.module.scss';
import TextWithTooltip from '../TextWithTooltip/TextWithTooltip';

interface SongNameWithPhotoProps {
  song: any;
}

const SongNameWithPhoto = (props: SongNameWithPhotoProps) => {
  const { song } = props;

  return (
    <div className={styles.Songs}>
      {song.thumbnail_img ? (
        <img
          src={`${MEDIA_URL}/${get(song, 'thumbnail_img', '')}`}
          alt="song image"
          className={styles.image}
        />
      ) : (
        <div className={styles.songName}>{get(song, 'title', '')[0]}</div>
      )}
      <p className={styles.title}>
        {/* {get(song, 'title', '')} */}

        <TextWithTooltip text={get(song, 'title', '')} />
      </p>
    </div>
  );
};

export default SongNameWithPhoto;
